export default {
    /**
     * @public
     * Location names in the db all look like: "Central Christian College - 30",
     * this method removes the trailing space, dash, and number
     * Eg: "Central Christian College - 30" to "Central Christian College"
     * @param { String } locationName
     * @returns { String }
     */
    locationNameToPrettyName( locationName ) {
        return ( locationName && typeof locationName === 'string' )
            ? locationName.replace( / -([^-]+)$/, '' ).trim()
            : locationName;
    },

    /**
     * @public
     * Returns a location name without 'Bookstore' on the end, if it is there
     * @param { String } locationName
     * @returns { String }
     */
    stripBookstoreFromLocationName( locationName ) {
        const nameWithNoNumber = this.locationNameToPrettyName( locationName );
        return nameWithNoNumber.includes( 'Bookstore' )
            ? nameWithNoNumber.split( 'Bookstore' )[ 0 ].trim()
            : nameWithNoNumber.trim();
    },

    /**
     * @public
     * Returns a location name without 'Bookstore' or 'Campus Store' on the end, if it is there
     * @param locationName { String }
     * @returns { String }
     */
    locationNameFriendly( locationName ) {
        return this.stripBookstoreFromLocationName( locationName ).includes( 'Campus Store' )
            ? this.stripBookstoreFromLocationName( locationName ).split( 'Campus Store' )[ 0 ].trim()
            : this.stripBookstoreFromLocationName( locationName ).trim();
    },
};
